import {useState,useEffect, useRef} from "react";
import { Link ,useLocation, useOutletContext, useNavigate } from "react-router-dom";
import CtntTop5InqApi from "Apis/CtntTop5InqApi";
import GameSvcCtntPstdLstInqApi from "Apis/GameSvcCtntLstInqApi";
import MgpStore from "Stores/Store";
import Pagination from "react-js-pagination";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import "Assets/css/Ctnt.css";
import { Helmet } from "react-helmet-async";
import ApiError from "Utils/ApiError";
import GamePageBanner from "Components/GamePageBanner";
import ApiResultModal from "Components/ApiResultModal";
import EditorUi, { type EditorUiHandle } from "Utils/Editor";
import CommuBrdRegApi from "Apis/CommuBrdRegApi";
import useRecaptcha from "Utils/useRecaptcha";
import { sanitizeContent } from "Utils/sanitizeConfig";
import CommuBrdCtgrLstApi from "Apis/CommuBrdCtgrLstApi"; // 게시판 카테고리 조회 API
// import CtntRegApi from "Apis/CtntRegApi"; // 실제 게시글 등록 API로 교체

interface CommuBrdCtgrNode {
    ctgrCd: string;
    subCtgrCd?: string;
    ctgrNm: string;
    prntCtgrCd: string | null;
    children: CommuBrdCtgrNode[];
}


const CommuWriteUi = ({gameSvcCd,ctntKindCd,ctntCtgrCdName,LstType}:any) => {
    const {gameMainPageData, langData}:any = useOutletContext();
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobileCategoryOpen, setIsMobileCategoryOpen] = useState(false);
    const [isBoardSelectOpen, setIsBoardSelectOpen] = useState(false);
    const [selectedBoardCode, setSelectedBoardCode] = useState<string>("");
    const [selectedSubCategoryCode, setSelectedSubCategoryCode] = useState<string>("");
    const boardSelectRef = useRef<HTMLDivElement | null>(null);
    const [isPrefixSelectOpen, setIsPrefixSelectOpen] = useState(false);
    const [selectedPrefixCode, setSelectedPrefixCode] = useState<string>("");
    const [titleInputState, setTitleInputState] = useState("");
    const [boardCtgrTree, setBoardCtgrTree] = useState<CommuBrdCtgrNode[]>([]);
    const prefixSelectRef = useRef<HTMLDivElement | null>(null);

    // 에디터 인스턴스 참조 — 등록 버튼에서 이미지 업로드를 트리거하기 위해 필요
    const editorRef = useRef<EditorUiHandle>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    // const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1);
    const [ctntTypeState,setctntTypeState] = useState<string|null>();
    
    // URL 파라미터 실시간 추출 (메뉴 변경 및 페이지 변경 감지용)
    const getCurrentParams = () => {
        const currentParams = new URLSearchParams(location.search);
        return {
            currentGameSvcCd: currentParams.get("gameSvcCd") || gameSvcCd,
            currentCtntCtgrCd: currentParams.get("ctntKindCd") || ctntKindCd,
            currentPage: parseInt(currentParams.get("page") || "1")
        };
    };
    
    const handlePageChange = (newPage:any) => {
        const { currentGameSvcCd, currentCtntCtgrCd } = getCurrentParams();
        
        // URL 파라미터 업데이트
        const newParams = new URLSearchParams(location.search);
        newParams.set("page", newPage.toString());
        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    };
    
    // 기존 파라미터 로직 (초기값 설정용)
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query = serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let getctntKindCd = query.get("ctntKindCd");
    
    if(getGameSvcCd != null){
        gameSvcCd = getGameSvcCd;
        ctntKindCd = getctntKindCd;
    }

    if(gameSvcCd == null) {
        gameSvcCd = location.state?.gameSvcCd;
    }
    if(ctntKindCd == null) {
        ctntKindCd = location.state?.ctntKindCd;
    }
    
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const [ctntKindCdState,setCtntKindCdState] = useState<any>();
    const [topFixCtntState,setTopFixCtntState] = useState<any>();
    const { getToken } = useRecaptcha();
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
    
    useEffect(()=>{
        const { currentGameSvcCd, currentCtntCtgrCd, currentPage } = getCurrentParams();
        
        // 페이지 상태 동기화
        setPageState(currentPage);
        

    }, [location.search, MgpStore.getState().LangSetState.Lang]); // location.search를 의존성에 추가

    useEffect(() => {
        CommuBrdCtgrLstApi()
            .then((Resp:any) => {
                if (Resp?.apiHdr?.code !== "COMM0000") {
                    ApiError(langData, Resp?.apiHdr?.code);
                    return;
                }
                setBoardCtgrTree(Resp?.apiBody?.ctgrLst || []);
            })
            .catch(() => {
                setBoardCtgrTree([]);
            });
    }, [MgpStore.getState().LangSetState.Lang]);

    const [ctntCtgrCdCd,setctntCtgrCdCd] = useState(ctntKindCd);
    
    // 현재 URL 파라미터를 한 번만 계산하고 저장
    const currentParams = getCurrentParams();
    
    // 현재 URL에서 대메뉴 찾기 (메뉴 데이터용)
    const currentMainMenu = gameMainPageData?.menu?.find((menu: any) => {
        if (currentParams.currentCtntCtgrCd) {
            return menu.subMenuLst?.some((sub: any) => {
                const urlParams = new URLSearchParams(sub.url?.split('?')[1] || '');
                const subCtntKindCd = urlParams.get('ctntKindCd');
                return subCtntKindCd === currentParams.currentCtntCtgrCd;
            });
        }
        const currentPath = location.pathname.toLowerCase();
        const menuCd = menu.menuCd?.toLowerCase() || '';
        return currentPath.includes(menuCd) || 
               menu.subMenuLst?.some((sub: any) => {
                   const subMenuCd = sub.menuCd?.toLowerCase() || '';
                   return currentPath.includes(subMenuCd);
               });
    });
    
    // 모바일 카테고리 메뉴 열림 시 body 스크롤 방지
    useEffect(() => {
        if (isMobileCategoryOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobileCategoryOpen]);

    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            if (boardSelectRef.current && !boardSelectRef.current.contains(event.target as Node)) {
                setIsBoardSelectOpen(false);
            }
            if (prefixSelectRef.current && !prefixSelectRef.current.contains(event.target as Node)) {
                setIsPrefixSelectOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        setSelectedBoardCode(currentParams.currentCtntCtgrCd || "");
    }, [location.search]);

    // 동적 메뉴 데이터 - 현재 대메뉴의 subMenuLst 추출
    const ctntMenuData = currentMainMenu?.subMenuLst?.map((subMenu: any) => {
        // URL에서 ctntKindCd 파라미터 추출
        const urlParams = new URLSearchParams(subMenu.url?.split('?')[1] || '');
        const ctntKindCd = urlParams.get('ctntKindCd') || subMenu.menuCd;
        
        return {
            Link: subMenu.url || '#',
            Txt: subMenu.menuNm,
            Display: subMenu.useYn,
            Code: ctntKindCd, // URL에서 추출한 ctntKindCd 사용
            BlankYn: subMenu.blankYn
        };
    }) || [];
    
    // 표시되는 메뉴만 필터링
    const visibleMenus = ctntMenuData.filter((menu: any) => menu.Display === "Y");
    const boardOptionList = boardCtgrTree.map((item) => ({
        code: item.ctgrCd,
        txt: item.ctgrNm,
    }));
    const selectedBoardInfo = boardCtgrTree.find((item) => item.ctgrCd === selectedBoardCode);
    const prefixOptionList = (selectedBoardInfo?.children || []).map((item) => ({
        code: item.subCtgrCd || item.ctgrCd,
        txt: item.ctgrNm,
    }));
    const selectedBoardName = boardOptionList.find((item) => item.code === selectedBoardCode)?.txt || "게시판 선택";

    const handleBoardSelect = (menu: { code: string; txt: string }) => {
        setIsBoardSelectOpen(false);
        if (!menu?.code) return;
        setSelectedBoardCode(menu.code);
        setSelectedPrefixCode("");
    };
    const selectedPrefixName = prefixOptionList.find((item) => item.code === selectedPrefixCode)?.txt || "말머리 선택";

    useEffect(() => {
        if (!selectedBoardCode && boardOptionList.length > 0) {
            setSelectedBoardCode(boardOptionList[0].code);
        }
    }, [boardOptionList, selectedBoardCode]);

    useEffect(() => {
        if (prefixOptionList.length === 0) {
            setSelectedPrefixCode("");
            return;
        }

        const hasSelected = prefixOptionList.some((item) => item.code === selectedPrefixCode);
        if (!hasSelected) {
            setSelectedPrefixCode(prefixOptionList[0].code);
        }
    }, [prefixOptionList, selectedPrefixCode]);

    useEffect(() => {
        setSelectedSubCategoryCode(selectedPrefixCode);
    }, [selectedPrefixCode]);

    const handlePrefixSelect = (option: { code: string; txt: string }) => {
        setIsPrefixSelectOpen(false);
        if (!option?.code) return;
        setSelectedPrefixCode(option.code);
    };

    // 등록 버튼 클릭 핸들러
    const handleSubmitClick = async () => {
        if (isSubmitting) return;

        if (!titleInputState.trim()) {
            alert("제목을 입력해 주세요");
            return;
        }
        if (!selectedBoardCode) {
            alert("게시판을 선택해 주세요");
            return;
        }

        setIsSubmitting(true);
        try {
            // 1) 에디터 안의 blob 이미지를 전부 업로드하고 최종 HTML을 받아온다
            const finalHtml = await editorRef.current?.uploadImagesAndGetHtml();
            const uploadMeta = editorRef.current?.getLastUploadMeta();
            const thumbnailUrl = uploadMeta?.thmbUrl || null;
            const rqstTrxId = uploadMeta?.rqstTrxId || null;
            const sanitizedHtml = sanitizeContent(finalHtml ?? "");
            const captchaToken = await getToken("commu_brd_reg");
            const resp:any = await CommuBrdRegApi(
                selectedBoardCode,
                selectedSubCategoryCode || null,
                titleInputState,
                sanitizedHtml,
                thumbnailUrl,
                rqstTrxId,
                captchaToken
            );

            if (resp?.apiHdr?.code === "MEMB0000") {
                openResultModal("게시글이 정상적으로 등록되었습니다.", () => {
                    navigate(`/community/Lst?gameSvcCd=${gameSvcCd}&ctntKindCd=${selectedBoardCode}&ctntCtgrCd=${selectedSubCategoryCode || ""}&page=1`);
                });
            } else {
                ApiError(langData, resp?.apiHdr?.code);
            }
            // 2) 실제 게시글 등록 API 호출 (프로젝트에 있는 등록 API로 교체)
            // await CtntRegApi({
            //     gameSvcCd,
            //     ctntKindCd: selectedBoardCode,
            //     prefixCd: selectedPrefixCode,
            //     titl: titleInputState,
            //     ctntCtxt: finalHtml,
            // });

            // 3) 등록 후 목록으로 이동 등
            // navigate(`/community/Lst?gameSvcCd=${gameSvcCd}&ctntKindCd=${selectedBoardCode}`);
        } catch (e) {
            alert("게시글 등록 중 오류가 발생했어요. 다시 시도해주세요.");
        } finally {
            setIsSubmitting(false);
        }
    };
    
    
    
    return(
        <>
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
            />
            {/* <Helmet>
                <title></title>
            </Helmet> */}
            <div className="BgW">
            <GamePageBanner gameMainPageData={gameMainPageData} langData={langData} />
            <div className="container1400 mt30">
                <button
                    className="mobileCategoryBtn"
                    onClick={() => setIsMobileCategoryOpen(!isMobileCategoryOpen)}
                >
                    <span>{visibleMenus.find((m:any)=>m.Code===currentParams.currentCtntCtgrCd)?.Txt || '카테고리'}</span>
                    <span className={`category-arrow ${isMobileCategoryOpen ? 'up' : 'down'}`}></span>
                </button>
                <h1 className="ctntCtgrTitlTxt">
                    <Link to="/community/Lst?gameSvcCd=BBO&ctntKindCd=PNOT" className="ctntCtgrTitlTxtLink">
                        COMMUNITY 
                    </Link>
                </h1>
                <div  className="ctntLstWrap ctntPstdLstWrap commuWriteWrap"> 
                    <div className="commuBoardSelectWrap" ref={boardSelectRef}>
                        <button
                            type="button"
                            className={`commuBoardSelectBtn ${isBoardSelectOpen ? "open" : ""}`}
                            onClick={() => setIsBoardSelectOpen((prev) => !prev)}
                            aria-haspopup="listbox"
                            aria-expanded={isBoardSelectOpen}
                        >
                            <span>{selectedBoardName}</span>
                            <span className="commuBoardSelectArrow" />
                        </button>

                        {isBoardSelectOpen && (
                            <ul className="commuBoardSelectList" role="listbox">
                                {boardOptionList.map((menu) => (
                                    <li key={menu.code} role="option" aria-selected={menu.code === selectedBoardCode}>
                                        <button
                                            type="button"
                                            className={menu.code === selectedBoardCode ? "active" : ""}
                                            onClick={() => handleBoardSelect(menu)}
                                        >
                                            {menu.txt}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
                <div className="ctntLstWrap ctntPstdLstWrap commuWriteWrap">
                    <div className="commuWriteInputRow">
                        <div className="commuPrefixSelectWrap" ref={prefixSelectRef}>
                            <button
                                type="button"
                                className={`commuPrefixSelectBtn ${isPrefixSelectOpen ? "open" : ""}`}
                                onClick={() => setIsPrefixSelectOpen((prev) => !prev)}
                                aria-haspopup="listbox"
                                aria-expanded={isPrefixSelectOpen}
                            >
                                <span>{selectedPrefixName}</span>
                                <span className="commuPrefixSelectArrow" />
                            </button>
                            {isPrefixSelectOpen && (
                                <ul className="commuPrefixSelectList" role="listbox">
                                    {prefixOptionList.map((option: any) => (
                                        <li key={option.code} role="option" aria-selected={option.code === selectedPrefixCode}>
                                            <button
                                                type="button"
                                                className={option.code === selectedPrefixCode ? "active" : ""}
                                                onClick={() => handlePrefixSelect(option)}
                                            >
                                                {option.txt}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div className="commuWriteTitleInputWrap">
                            <input
                                type="text"
                                className="commuWriteTitleInput"
                                value={titleInputState}
                                onChange={(e) => setTitleInputState(e.currentTarget.value)}
                                placeholder="제목을 입력해 주세요"
                                maxLength={100}
                            />
                        </div>
                    </div>
                </div>
                <div className="ctntLstWrap ctntPstdLstWrap commuWriteWrap">
                    <EditorUi ref={editorRef}/>
                </div>
                <div className="commuWriteBtnWrap">
                    <button onClick={handleSubmitClick} disabled={isSubmitting}>
                        <p>{isSubmitting ? "등록 중..." : "등록"}</p>
                    </button>
                </div>
            </div>
        </div>
        </>
    )
}
export default CommuWriteUi;